module.exports = __webpack_public_path__ + "static/media/nocustomer_detail.5c4ad62a.svg";